var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yy-tree"},_vm._l((_vm.rootNode.children),function(node){return _c('TreeNode',{key:node.key,attrs:{"level":0,"node":node}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }